import { Component, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconComponent } from '@examdojo/core/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { ImagePreviewDirective } from './image-preview.directive';

@Component({
  selector: 'dojo-image-preview-with-button',
  template: `
    <div class="group relative flex h-full w-full items-center justify-center">
      <ng-content>
        <img [src]="srcUrl()" />
      </ng-content>
      @if (!hideButton()) {
        <button
          class="absolute bottom-2 right-2 flex rounded-[0.5rem] bg-neutral-100 p-2 text-neutral-700 md:hidden md:group-hover:flex"
          [matTooltip]="'examdojo.enlarge' | transloco"
          (click)="onButtonClick($event)"
        >
          <dojo-icon [icon]="'arrow-up-right-and-arrow-down-left-from-center'" [size]="14" />
        </button>
      }
    </div>
  `,
  standalone: true,
  imports: [IconComponent, MatTooltipModule, TranslocoPipe],
  hostDirectives: [
    {
      directive: ImagePreviewDirective,
      inputs: ['src', 'buttonOnly'],
    },
  ],
})
export class ImagePreviewWithButtonComponent {
  constructor(private readonly imagePreviewDirective: ImagePreviewDirective) {}

  readonly hideButton = input<boolean>(false);
  readonly srcUrl = this.imagePreviewDirective.srcUrl;

  onButtonClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.imagePreviewDirective.openPreview();
  }
}
